import React from 'react';
import { Card, Form, Select, DatePicker, Button, Space, Input, Slider } from 'antd';
import { FilterOutlined, ClearOutlined } from '@ant-design/icons';
import { QuestionnaireFilters } from '../../types/questionnaire';
import type { ChannelInfo } from '../../types/channel';

const { RangePicker } = DatePicker;
const { Option } = Select;

interface ScreeningFiltersProps {
  filters: QuestionnaireFilters;
  onFiltersChange: (filters: QuestionnaireFilters) => void;
  onClearFilters: () => void;
  channels?: ChannelInfo[]; // 渠道列表
}

export const ScreeningFilters: React.FC<ScreeningFiltersProps> = ({
  filters,
  onFiltersChange,
  onClearFilters,
  channels = [],
}) => {
  const [form] = Form.useForm();

  const handleValuesChange = (changedValues: any, allValues: any) => {
    // 处理特殊字段的数据格式
    const processedValues = { ...allValues };
    
    // 处理搜索字段
    if (changedValues.search !== undefined) {
      processedValues.search = changedValues.search || '';
    }
    
    // 处理评分范围
    if (changedValues.scoreRange !== undefined) {
      processedValues.scoreRange = changedValues.scoreRange || [0, 100];
    }
    
    console.log('筛选条件变化:', processedValues);
    onFiltersChange(processedValues);
  };

  return (
    <Card
      title={
        <Space>
          <FilterOutlined />
          智能筛选
        </Space>
      }
      size="small"
      extra={
        <Button 
          size="small" 
          icon={<ClearOutlined />} 
          onClick={() => {
            form.resetFields();
            onClearFilters();
          }}
        >
          清除
        </Button>
      }
    >
      <Form
        form={form}
        layout="inline"
        initialValues={filters}
        onValuesChange={handleValuesChange}
        size="small"
        style={{ width: '100%' }}
      >
        <Form.Item name="status" label="状态" style={{ marginBottom: 8 }}>
          <Select
            mode="multiple"
            placeholder="选择状态"
            allowClear
            style={{ minWidth: 120 }}
          >
            <Option value="draft">草稿</Option>
            <Option value="submitted">已提交</Option>
            <Option value="under_review">审核中</Option>
            <Option value="approved">已通过</Option>
            <Option value="rejected">已拒绝</Option>
          </Select>
        </Form.Item>

        <Form.Item name="industry" label="行业" style={{ marginBottom: 8 }}>
          <Select
            mode="multiple"
            placeholder="选择行业"
            allowClear
            style={{ minWidth: 120 }}
          >
            <Option value="energy">能源</Option>
            <Option value="manufacturing">制造业</Option>
            <Option value="real_estate">房地产</Option>
            <Option value="finance">金融服务</Option>
            <Option value="technology">科技</Option>
          </Select>
        </Form.Item>

        <Form.Item name="creditRating" label="评级" style={{ marginBottom: 8 }}>
          <Select
            mode="multiple"
            placeholder="选择评级"
            allowClear
            style={{ minWidth: 100 }}
          >
            <Option value="AAA">AAA</Option>
            <Option value="AA+">AA+</Option>
            <Option value="AA">AA</Option>
            <Option value="AA-">AA-</Option>
            <Option value="A+">A+</Option>
            <Option value="A">A</Option>
          </Select>
        </Form.Item>

        <Form.Item name="scoreRange" label="AI评分" style={{ marginBottom: 8 }}>
          <Slider
            range
            min={0}
            max={100}
            defaultValue={[0, 100]}
            style={{ width: 150 }}
            tooltip={{ formatter: (value) => `${value}分` }}
          />
        </Form.Item>

        <Form.Item name="search" label="搜索" style={{ marginBottom: 8 }}>
          <Input.Search
            placeholder="项目名称或发行人"
            allowClear
            style={{ width: 200 }}
          />
        </Form.Item>

        <Form.Item name="channel" label="渠道" style={{ marginBottom: 8 }}>
          <Select
            mode="multiple"
            placeholder="选择渠道"
            allowClear
            style={{ minWidth: 150 }}
            size="small"
          >
            {channels.map(channel => (
              <Option key={channel._id || channel.id} value={channel.code}>
                {channel.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="dateRange" label="提交时间" style={{ marginBottom: 8 }}>
          <RangePicker size="small" />
        </Form.Item>
      </Form>
    </Card>
  );
};